import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { DropdownOption } from "@RGVSI/Shared/Types/Interfaces/dropdown-option.interface";

import { PorfolioDistributionRepository } from "../Repositories/portfolio-distribution.repository";
import { PorfolioDistribution } from "../Types/Interfaces/portfolio-distribution.interface";

@Injectable()
export class PorfolioDistributionService {
  constructor(private agingBalanceRepository: PorfolioDistributionRepository) {}

  public getMonedas(): Observable<DropdownOption[]> {
    return this.agingBalanceRepository.getMonedas();
  }

  public getPorfolioDistributions(currencyCode: string): Observable<PorfolioDistribution[]> {
    return this.agingBalanceRepository.getPorfolioDistributions(currencyCode);
  }
}
